// extracted by mini-css-extract-plugin
export default {"wrapper":"AssistantSearchSharePieChartTool_wrapper__11jtT"};